import React, {useEffect, useState} from 'react';
import { Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import MainPage from "../pages/main-page";
import QuotePage from "../pages/quote-page";
import ApplicationPage from "../pages/application-page";
import PaymentPage from "../pages/payment-page";
import FinishPage from "../pages/finish-page";
import Tts from "../ui/tts/tts";
import RedirectPage from "../pages/redirect-page";
import {_getSite, _setSite} from "../store/system/service";
import {_findQuote, _setAgentCode} from "../store/policy/service";
import {connect} from "react-redux";
import * as propTypes from "prop-types";

let history;

export function getHistory() {
    if (!history) {
        history = createBrowserHistory();
    }

    return history;
}

const Routes = (props) => {
    useEffect(() => {
        console.log('site = ' + props.site+ ", newSite = " + props.newSite);
        if (!props.site) {
            props.setSite(props.newSite);
            if(props.newSite==='mla'){
                props.setAgentCode('01000772')
            } else if (props.newSite==='bm'){
                props.setAgentCode('05L00070')
            }
        }
    }, []);

    return (
        <>
            <Route path={(props.newSite ? '/' + props.newSite : '') + '/'} exact component={MainPage} />
            <Route path={(props.newSite ? '/' + props.newSite : '') + '/quote'} exact component={QuotePage} />
            <Route path={(props.newSite ? '/' + props.newSite : '') + '/quote/:section'} component={QuotePage} />
            <Route path={(props.newSite ? '/' + props.newSite : '') + '/application'} exact component={ApplicationPage} />
            <Route path={(props.newSite ? '/' + props.newSite : '') + '/application/:section'} component={ApplicationPage} />
            <Route path={(props.newSite ? '/' + props.newSite : '') + '/payment'} component={PaymentPage} />
            <Route path={(props.newSite ? '/' + props.newSite : '') + '/finish'} component={FinishPage} />
        </>
    );
}


const mapStateToProps = (state) => {
    let site = _getSite(state);
    let newSite = site;
    if (!site) {
        let url = window.location.href;
        if (url.indexOf('/bm') != -1 || url.indexOf('bm.') != -1 || url.indexOf('#bm') != -1) {
            newSite = 'bm';
        } else if (url.indexOf('/gnm') != -1 || url.indexOf('gnm.') != -1 || url.indexOf('#gnm') != -1) {
            newSite = 'gnm'
        } else if (url.indexOf('/mla') != -1 || url.indexOf('mla.') != -1 || url.indexOf('#mla') != -1) {
            newSite = 'mla'
        }
        else {
            newSite = '';
        }
    }
    return {
        site: site,
        newSite: newSite
    }
}

const mapDispatchToProps = {
    setSite: _setSite,
    setAgentCode: _setAgentCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
